<template>
  <b-card
    v-if="
      $can('add_project_request', 'Projets') ||
      $can('track_budget', 'Projets') ||
      $can('track_payments', 'Projets')
    "
    no-body
    class="border-primary"
  >
    <b-card-body>
      <!-- expense button -->
      <expense-handler
        v-if="$can('add_project_request', 'Projets') && isWon && !isClosed"
        :opportunityId="projectData.uid"
        class="mb-2"
        @expenseAdded="expenseHandled"
      />
      <!-- budget tracking -->
      <b-button
        v-if="$can('track_budget', 'Projets')"
        :to="{
          name:
            projectData.budget_state == 'réel'
              ? 'tracking-real'
              : 'budget-trancking-add',
          params: { id: projectData.uid },
        }"
        class="mb-2"
        block
        variant="warning"
      >
        Suivi Budget
      </b-button>

      <!-- Payment Status Section -->
      <div v-if="isWon && !isClosed">
        <!-- Pending Payment Alert -->
        <b-alert v-if="isPendingPayment" variant="warning" show class="mb-2">
          <div class="alert-body">
            <h6 class="alert-heading mb-50">En attente de paiement</h6>
            <p class="mb-50 small">
              Le client doit procéder au paiement pour finaliser le projet.
            </p>
            <b-button
              v-if="$can('track_payments', 'Projets')"
              size="sm"
              variant="success"
              @click="markAsPaid"
            >
              <feather-icon icon="CheckCircleIcon" class="mr-50" />
              Marquer comme payé
            </b-button>
          </div>
        </b-alert>

        <!-- Payment Confirmed Info -->
        <b-alert v-if="isPaid" variant="success" show class="mb-2">
          <div class="alert-body">
            <h6 class="alert-heading mb-50">Paiement confirmé</h6>
            <p class="mb-0 small">
              <feather-icon icon="CheckIcon" class="mr-50" size="14" />
              Payé le {{ formatDate(paidAt) }}
            </p>
          </div>
        </b-alert>
      </div>

      <!-- paiement status -->
      <b-button
        v-if="$can('track_payments', 'Projets') && !isClosed && isWon"
        :to="{
          name: 'project-payment-status',
          params: { id: projectData.uid },
        }"
        block
        variant="info"
      >
        État Paiements
      </b-button>
      <!-- define project state -->
      <b-button
      v-if="!isLost && !isWon && !isClosed"
        block
        variant="danger"
        @click="toggleAsLost"
      >
        Définir comme Perdu
      </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BButton, BAlert } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ExpenseHandler from "@/components/expenses/ExpenseHandler.vue";
import useProjectDetails from './useProjectDetails';
import { toRefs } from '@vue/composition-api';

export default {
  props: {
    projectData: {
      type: Object,
      required: true,
    },
    projectUpdated: Boolean,
  },
  components: {
    BCard,
    BCardBody,
    BButton,
    BAlert,
    ExpenseHandler,
  },
  computed: {
    responsable() {
      return this.projectData.assignee?.name;
    },
  },
  methods: {
    expenseHandled() {
      this.$emit("projectUpdated");
    },
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
  setup(props, { emit }) {
    const {
      toggleAsLost,
      markAsPaid,
      isWon,
      isLost,
      isClosed,
      hasProjectExpenses,
      isPendingPayment,
      isPaid,
      paidAt,
      paidBy,
    } = useProjectDetails(toRefs(props), emit)
    return {
      toggleAsLost,
      markAsPaid,
      isWon,
      isLost,
      isClosed,
      hasProjectExpenses,
      isPendingPayment,
      isPaid,
      paidAt,
      paidBy,
    };
  },
};
</script>

<style></style>
